import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishPreparationPage } from '../../../dish/dish-create/dish-cost/dish-preparation/dish-preparation';
import { ProductCreateFoodcostPreparationPage } from '../../../products/product-create/product-create-foodcost/product-create-foodcost-preparation/product-create-foodcost-preparation';


/**
 * Generated class for the ArticleViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-preparation',
    templateUrl: 'article-view-preparation.html',
})
export class ArticleViewPreparationPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    edit() {
        if (this.article.type === 'dish') {
            if (this.globals.checkLimitsByLicense('dishes', 'recipe')) {
                this.navCtrl.push(DishPreparationPage, {
                    dish_uid: this.article.UID,
                    recipe: this.article.recipe,
                    tools: this.article.tools,
                    time: this.article.time,
                    time_cooking: this.article.time_cooking,
                    difficulty: this.article.difficulty,
                    preparation: this.article.preparation,
                    dish_name: this.globals.nameLangSelectDish(this.article),
                    dish: this.article,
                    update: true,
                });
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        } else {
            this.navCtrl.push(ProductCreateFoodcostPreparationPage, {
                update_state: true,
                product_uid: this.article.UID,
                recipe: this.article.recipe,
                tools: this.article.tools,
                time: this.article.time,
                time_cooking: this.article.time_cooking,
                difficulty: this.article.difficulty,
                preparation: this.article.preparation,
                product_name: this.globals.nameLangSelectProduct(this.article),
                product: this.article
            })
        }

    }
}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-preparation/article-view-preparation.ts